// import { Box, Divider, Center } from "@chakra-ui/react";

// import LinkedInIcon from "@mui/icons-material/LinkedIn";
import { Link } from "react-router-dom";
import {
  Box,
  Button,
  Container,
  Heading,
  Stack,
  Text,
  useBreakpointValue,
} from "@chakra-ui/react";

const Success = () => (
  <Box as="section" bg="bg-surface">
    <Container py={{ base: "16", md: "24" }}>
      <Stack spacing={{ base: "8", md: "10" }}>
        <Stack spacing={{ base: "4", md: "5" }} align="center">
          <Heading
            as="h1"
            size="xl"
            fontWeight="bold"
            color="primary.800"
            textAlign={["center", "center", "left", "left"]}
          >
            Success!
          </Heading>
          <Heading
            as="h2"
            size="md"
            color="primary.800"
            opacity="0.8"
            fontWeight="normal"
            lineHeight={1.5}
            textAlign={["center", "center", "left", "left"]}
          >
            Thank you for your submission. If you have another role you would
            like to submit please click the button below.
          </Heading>
        </Stack>
        <Stack
          spacing="3"
          direction={{ base: "column", sm: "row" }}
          justify="center"
        >
          <Link to={"/recruitme"}>
            <Button
              colorScheme="teal"
              borderRadius="8px"
              py="4"
              px="4"
              lineHeight="1"
              size="md"
            >
              Recruit me
            </Button>
          </Link>
        </Stack>
      </Stack>
    </Container>
  </Box>
);

export default Success;
